import {VscClose} from 'react-icons/vsc';
import CheckSuccess from '../Icons/CheckSuccess';
import {IEnquiryFormDictionary} from '@/dictionaries/components/enquiryForm/types';

interface SubmittedModalProps {
  formDict: IEnquiryFormDictionary;
  setOpenSubmittedModal: (open: boolean) => void;
}

export default function SubmittedModal({
  formDict,
  setOpenSubmittedModal,
}: SubmittedModalProps) {
  return (
    <div className="fixed top-0 left-0 flex justify-start sm:justify-center items-start sm:items-center bg-black/60 w-full h-[100vh] z-[999]">
      <div className="relative flex flex-col justify-start items-center w-full sm:w-1/2 px-10 py-[50px] bg-white gap-4">
        <button
          className="absolute top-[10px] desktop:-top-[10px] right-[10px] desktop:-right-[10px] flex justify-center items-center w-10 h-10 bg-white shadow-default rounded-full z-10"
          onClick={() => setOpenSubmittedModal(false)}>
          <VscClose className="w-7 h-7 text-gray-500" />
        </button>
        <CheckSuccess />
        <h3 className="text-2xl text-success font-averta-semibold">
          {formDict.submitted.title}
        </h3>
        <p className="text-center text-lg">{formDict.submitted.description}</p>
      </div>
    </div>
  );
}
